import { useGetExternalAccountsList } from '@/hooks/requests/useExternalAccounts';
import { ExternalBankAccountStatus } from '@/types/externalAccounts';
import { useState } from 'react';
import { SVLoader, SVTable } from '../core';
import { SVTableRow } from '@/types/common';
import { ROUTES } from '@/constants/routes';

type ExternalAccountsListProps = {
  status: ExternalBankAccountStatus;
  customerId?: string;
};

export default function ExternalAccountsList({
  status,
  customerId,
}: ExternalAccountsListProps) {
  const [page, setPage] = useState(0);
  const { externalAccounts, externalAccountsIsPending, totalRecordCount } =
    useGetExternalAccountsList(
      customerId
        ? { statuses: [status], page, consumer_ids: [customerId] }
        : { statuses: [status], page },
    );

  if (externalAccountsIsPending) {
    return <SVLoader />;
  }

  const rows: SVTableRow[] = externalAccounts.map(account => {
    const { uuid, accountName, consumer, lastUpdatedAt } = account;

    return {
      key: uuid,
      cells: [
        {
          key: `${uuid}AccountName`,
          content: accountName,
          type: 'text',
        },
        {
          key: `${uuid}Company`,
          content: consumer.companyName,
          type: 'text',
        },
        {
          key: `${uuid}Customer`,
          content: consumer.fullName,
          type: 'text',
        },
        {
          key: `${uuid}LastUpdated`,
          content: lastUpdatedAt,
          type: 'date',
        },
        {
          key: `${uuid}Details`,
          content: `${ROUTES.EXTERNAL_ACCOUNTS}/${uuid}`,
          type: 'link',
        },
      ],
    };
  });

  return (
    <SVTable
      ariaLabel="External Accounts List"
      headers={[
        {
          key: 'account',
          content: 'Account',
        },
        {
          key: 'company',
          content: 'Company',
        },
        {
          key: 'customer',
          content: 'Customer',
        },
        {
          key: 'lastUpdated',
          content: 'Last Updated',
        },
        {
          key: 'details',
          content: '',
        },
      ]}
      rows={rows}
      hasPagination
      page={page}
      setPage={setPage}
      totalRecordCount={totalRecordCount}
      emptyTableContent="No external accounts to display"
    />
  );
}
